/**
 * This route is dynamically added to the app if this section is
 * enabled inside the config for the tenant being built.
 */
// @ngInject
function states($stateProvider) {
  $stateProvider.state('external-loyalty', {
    parent: 'root',
    url: '/external-loyalty',
    templateUrl: 'apps/external-loyalty/templates/acp-external-loyalty.ng.html',
    data: {
      permissions: {
        only: 'external_loyalty_eligible',
        redirectTo: {
          external_loyalty_eligible: 'dashboard'
        }
      }
    },
    resolve: {
      module: /* @ngInject */ function($ocLazyLoad) {
        return import(/* webpackChunkName: "acp.section.external-loyalty" */ 'apps/external-loyalty').then(
          $ocLazyLoad.loadModule
        );
      }
    }
  });
}

export default states;
